import React, { useState } from "react"
import PropTypes from "prop-types"
import Autosuggest from "react-autosuggest"
import { getAutosuggestOptions } from "../../utils/autosuggestFunctions"
import "./AutosuggestBar.scss"

const AutosuggestBar = (props) => {
  const [suggestions, setSuggestions] = useState([])

  const onSuggestionSelected = (event, { suggestion }) => {
    const selectedData = props.data.find((a) => a === suggestion)
    props.setInput(selectedData.name)
    props.onSelect({
      id: selectedData.id,
      name: selectedData.name,
    })
    setSuggestions([])
  }

  const onChange = (event, { newValue }) => {
    props.onSelect({})
    if (newValue === "") {
      props.setInput("")
      setSuggestions([])
    } else {
      props.setInput(newValue)
    }
  }

  return (
    <div className="AutosuggestBar">
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={({ value }) => {
          props.setInput(value)
          setSuggestions(
            Array.from(
              new Set(
                getAutosuggestOptions(value.trim().toLowerCase(), props.data)
              )
            )
          )
        }}
        onSuggestionsClearRequested={() => setSuggestions([])}
        getSuggestionValue={(value) => value.name}
        renderSuggestion={(value) => (
          <div>
            {value.name} {value.subName && `(${value.subName})`}
          </div>
        )}
        inputProps={{
          placeholder: props.placeholder,
          value: props.input,
          title: "search-input",
          id: "search-input",
          type: "search",
          onChange: onChange,
        }}
        onSuggestionSelected={onSuggestionSelected}
        focusInputOnSuggestionClick={false}
      />
      {props.input !== "" ? (
        <span
          className="clear-input fa fa-times"
          onClick={() => {
            props.setInput("")
            props.onSelect({})
            setSuggestions([])
          }}
        />
      ) : (
        ""
      )}
      <label className="hidden" for="search-input">
        Search Input
      </label>
    </div>
  )
}

AutosuggestBar.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      subName: PropTypes.string,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  input: PropTypes.string.isRequired,
  setInput: PropTypes.func.isRequired,
}

AutosuggestBar.defaultProps = {
  placeholder: "Enter Text",
}

export default AutosuggestBar
